import axios from 'axios';
import { API_URL } from '../config/api.js';

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Tenant API
export const tenantApi = {
  async getAll(page = 1, limit = 20) {
    const response = await api.get(`/tenants?page=${page}&limit=${limit}`);
    return response.data;
  },

  async getById(id: string) {
    const response = await api.get(`/tenants/${id}`);
    return response.data;
  },

  async create(data: {
    name: string;
    domain: string;
    azureTenantId: string;
    azureClientId: string;
    azureClientSecret: string;
  }) {
    const response = await api.post('/tenants', data);
    return response.data;
  },

  async update(id: string, data: Partial<{
    name: string;
    azureClientSecret: string;
    isActive: boolean;
  }>) {
    const response = await api.put(`/tenants/${id}`, data);
    return response.data;
  },

  async delete(id: string) {
    const response = await api.delete(`/tenants/${id}`);
    return response.data;
  },
};

export default api;
